{
    "name": "scope-frontend",
    "version": "4.11.3",
    "private": true,
    "scripts": {
        "ng": "ng",
        "start": "ng serve --open",
        "refresh": "ng serve",
        "build": "ng build --localize",
        "build:development": "ng build --localize --configuration=development",
        "build:staging": "ng build --localize --configuration=staging && pnpm sentry:sourcemaps",
        "build:production": "ng build --localize --configuration=production",
        "lint": "eslint",
        "lint:fix": "eslint --fix",
        "format": "eslint --fix && prettier \"**/*.{ts,html,scss}\" --write",
        "watch": "ng build --watch --configuration=local",
        "i18n": "ng extract-i18n --output-path src/locales --format=xlf",
        "glossaries": "node ./ci/deepl/glossaries.js",
        "translate": "node ./ci/deepl/translate.js",
        "usage": "node ./ci/deepl/usage.js",
        "test": "jest --watchAll",
        "test:ci": "jest --ci",
        "docs:watch": "compodoc -p tsconfig.doc.json --includes ci/deepl --includesName i18n --theme material -d docs -s -o -w",
        "docs:build": "compodoc -p tsconfig.doc.json --includes ci/deepl --includesName i18n --theme material -d docs",
        "docs:run": "compodoc -p tsconfig.doc.json --includes ci/deepl --includesName i18n --theme material -d docs -s",
        "docs:serve": "compodoc -p tsconfig.doc.json --includes ci/deepl --includesName i18n --theme material -d docs -s -o",
        "cypress": "ng e2e",
        "cypress:ci": "ng run scope-frontend:cypress-run",
        "sentry:sourcemaps": "sentry-cli sourcemaps inject --org riege --project angular-frontend ./dist && sentry-cli sourcemaps upload --org riege --project angular-frontend ./dist"
    },
    "dependencies": {
        "@angular/animations": "18.2.13",
        "@angular/cdk": "18.2.14",
        "@angular/common": "18.2.13",
        "@angular/compiler": "18.2.13",
        "@angular/core": "18.2.13",
        "@angular/forms": "18.2.13",
        "@angular/material": "18.2.14",
        "@angular/platform-browser": "18.2.13",
        "@angular/platform-browser-dynamic": "18.2.13",
        "@angular/router": "18.2.13",
        "@azure/msal-angular": "^3.0.25",
        "@azure/msal-browser": "^3.26.1",
        "@azure/msal-common": "^14.15.0",
        "@maptiler/client": "^2.0.0",
        "@material/layout-grid": "^14.0.0",
        "@microsoft/applicationinsights-angularplugin-js": "^15.3.3",
        "@microsoft/applicationinsights-web": "^3.3.3",
        "@sentry/angular-ivy": "^7.114.0",
        "@sentry/cli": "^2.37.0",
        "@sentry/integrations": "^7.114.0",
        "@sentry/webpack-plugin": "^2.22.5",
        "bulma-scss": "^0.9.4",
        "keen-slider": "^6.8.6",
        "maplibre-gl": "^4.7.1",
        "material-icons": "^1.13.12",
        "ngx-cookie-service": "^18.0.0",
        "ngx-matomo-client": "^6.3.1",
        "rxjs": "~7.8.1",
        "stream-browserify": "^3.0.0",
        "tslib": "^2.7.0",
        "typescript": "5.5.4",
        "xng-breadcrumb": "^12.0.0",
        "zone.js": "0.15.0"
    },
    "devDependencies": {
        "@angular-eslint/builder": "18.4.3",
        "@angular-eslint/eslint-plugin": "18.4.3",
        "@angular-eslint/eslint-plugin-template": "18.4.3",
        "@angular-eslint/schematics": "18.4.3",
        "@angular-eslint/template-parser": "18.4.3",
        "@angular/build": "^18.2.8",
        "@angular/cli": "18.2.17",
        "@angular/compiler-cli": "18.2.13",
        "@angular/localize": "18.2.13",
        "@babel/core": "^7.25.8",
        "@babel/plugin-transform-private-methods": "^7.25.7",
        "@commitlint/cli": "^19.5.0",
        "@commitlint/config-conventional": "^19.5.0",
        "@compodoc/compodoc": "^1.1.26",
        "@cypress/schematic": "^3.0.0",
        "@eslint/compat": "^1.2.0",
        "@eslint/eslintrc": "^3.1.0",
        "@eslint/js": "^9.12.0",
        "@jest/globals": "^29.7.0",
        "@ngtools/webpack": "^18.2.8",
        "@schematics/angular": "^18.2.8",
        "@testing-library/angular": "^17.3.1",
        "@testing-library/cypress": "^10.0.2",
        "@types/geojson": "^7946.0.14",
        "@types/jest": "^29.5.13",
        "@types/node": "^22.0.0",
        "@types/supercluster": "^7.1.3",
        "@typescript-eslint/eslint-plugin": "8.21.0",
        "@typescript-eslint/parser": "8.21.0",
        "cypress": "^14.0.0",
        "deepl-node": "^1.15.0",
        "dotenv": "^16.4.5",
        "eslint": "^9.12.0",
        "eslint-config-prettier": "^9.1.0",
        "eslint-plugin-cypress": "^4.0.0",
        "eslint-plugin-import": "^2.31.0",
        "eslint-plugin-jsdoc": "^50.4.1",
        "eslint-plugin-prettier": "^5.2.1",
        "fast-xml-parser": "^4.5.0",
        "jest": "^29.7.0",
        "jest-preset-angular": "^14.2.4",
        "ng-mocks": "^14.13.1",
        "prettier-eslint": "^16.3.0",
        "ts-jest": "^29.2.5",
        "xliff": "^6.2.1"
    },
    "packageManager": "pnpm@9.14.4"
}
